module.exports = {
	"config": {
		"canonicalUrl": "https://paramsen.github.io",
		"siteTitle": "Pär Amsens Code",
		"siteDescr": "A blog about software, hardware and middleware.",
		"siteAuthor": "Pär Nils Amsen",
		"siteGithubUrl": "https://github.com/paramsen",
		"siteEmailUrl": "par.nils.amsen@gmail.com",
		"siteTwitterUrl": "https://twitter.com/parnilsamsen",
		"twitterUser": "parnilsamsen",
		"googleAnalyticsId": "UA-97098585-1",
		"disqusShortName": "paramsen-github-io",
		"linkPrefix": "/"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx"
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md"
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-04-09-1hr-diy-reactjs-blog",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-04-09-1hr-diy-reactjs-blog",
				"stem": "index",
				"path": "articles/2017-04-09-1hr-diy-reactjs-blog/index.md"
			},
			"requirePath": "articles/2017-04-09-1hr-diy-reactjs-blog/index.md",
			"path": "/a-quick-github-pages-blog/",
			"data": {
				"id": 3,
				"title": "A Github Pages blog in one hour",
				"date": "2017-04-10T16:00:00Z",
				"layout": "post",
				"path": "/a-quick-github-pages-blog/",
				"category": "Friday Evening Hacking",
				"description": "I've been working on my over-ambitious blog for a year. Node.js backend serving a prerendered React.js blog, MongoDB, Nginx and all the stuff. Last night I decided to scrape it all and start fresh. One hour later I got this blog published, React.js and Webpack on Github Pages. Here's how I made it."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-04-11-building-torch-android-1",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-04-11-building-torch-android-1",
				"stem": "index",
				"path": "articles/2017-04-11-building-torch-android-1/index.md"
			},
			"requirePath": "articles/2017-04-11-building-torch-android-1/index.md",
			"path": "/building-torch-android-01/",
			"data": {
				"id": 4,
				"title": "Building torch-android and staying sane",
				"date": "2017-04-11T19:00:00Z",
				"layout": "post",
				"path": "/building-torch-android-01/",
				"readNext": "/torch-android-vagrant-build-box/",
				"category": "Building torch-android",
				"description": "The machine learning lib Torch is available for Android as torch-android, but requires the occasional dev to have extensive knowledge in C, C++, cmake, ANT, NDK etc. This article series will cover how to build, develop, stay sane and get torch-android rocking."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-04-13-building-torch-android-2",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-04-13-building-torch-android-2",
				"stem": "index",
				"path": "articles/2017-04-13-building-torch-android-2/index.md"
			},
			"requirePath": "articles/2017-04-13-building-torch-android-2/index.md",
			"path": "/torch-android-vagrant-build-box/",
			"data": {
				"id": 5,
				"title": "Vagrant build box for torch-android",
				"date": "2017-04-15T12:00:00Z",
				"layout": "post",
				"path": "/torch-android-vagrant-build-box/",
				"category": "Building torch-android",
				"description": "Automated Vagrant build box for the torch-android binaries using the latest Android SDK and NDK. One command and you'll have the binaries, headers, lua-libs built for ARMv7 and ARM64v8.",
				"repo": "https://github.com/paramsen/torch-android-build-box",
				"readNext": "/torch-cmake-and-android-studio/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-04-19-building-torch-android-3",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-04-19-building-torch-android-3",
				"stem": "index",
				"path": "articles/2017-04-19-building-torch-android-3/index.md"
			},
			"requirePath": "articles/2017-04-19-building-torch-android-3/index.md",
			"path": "/torch-cmake-and-android-studio/",
			"data": {
				"id": 6,
				"title": "Torch, cmake and Android Studio",
				"date": "2017-04-19T12:00:00Z",
				"layout": "post",
				"path": "/torch-cmake-and-android-studio/",
				"category": "Building torch-android",
				"description": "Setting up Torch in Android Studio with the Gradle-cmake-ndk buildchain is the next step. I've created a working template project that will show how it's done.",
				"repo": "https://github.com/paramsen/torch-android-build-box"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-05-11-gradle-module-dependencies",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-05-11-gradle-module-dependencies",
				"stem": "index",
				"path": "articles/2017-05-11-gradle-module-dependencies/index.md"
			},
			"requirePath": "articles/2017-05-11-gradle-module-dependencies/index.md",
			"path": "/gradle-module-dependencies/",
			"data": {
				"id": 7,
				"title": "Gradle module-to-module dependencies",
				"date": "2017-05-11T20:00:00Z",
				"layout": "post",
				"path": "/gradle-module-dependencies/",
				"category": "Android Studio & Gradle",
				"description": "It can be a hassle to add a dependency that isn't published to a public repo like jcenter, the best approach is to add it as a Gradle separate module. Here's how.",
				"repo": "https://github.com/paramsen/gradle-module-dependency"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-05-14-android-exclude-tablets",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-05-14-android-exclude-tablets",
				"stem": "index",
				"path": "articles/2017-05-14-android-exclude-tablets/index.md"
			},
			"requirePath": "articles/2017-05-14-android-exclude-tablets/index.md",
			"path": "/exclude-tablets/",
			"data": {
				"id": 8,
				"title": "Exclude tablets while including large displays",
				"date": "2017-05-14T20:00:00Z",
				"layout": "post",
				"path": "/exclude-tablets/",
				"category": "Android",
				"description": "We excluded tablets according to the instructions in the Android doc. Apparently we also excluded all devices produced after Q2 2016 that have high res displays. Luckily Google gave us a hand and a solution."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-06-01-crashlytics-ndk-and-cmake",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-06-01-crashlytics-ndk-and-cmake",
				"stem": "index",
				"path": "articles/2017-06-01-crashlytics-ndk-and-cmake/index.md"
			},
			"requirePath": "articles/2017-06-01-crashlytics-ndk-and-cmake/index.md",
			"path": "/crashlytics-ndk-and-cmake/",
			"data": {
				"id": 11,
				"title": "Crashlytics NDK with Cmake",
				"date": "2017-06-01T23:30:00Z",
				"layout": "post",
				"path": "/crashlytics-ndk-and-cmake/",
				"category": "Android",
				"description": "Getting Crashlytics NDK working with the new Cmake buildchain requires forensic Google skillz. Here's how to just get it working instead."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-06-01-get-crashlytics-ndk-working",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-06-01-get-crashlytics-ndk-working",
				"stem": "index",
				"path": "articles/2017-06-01-get-crashlytics-ndk-working/index.md"
			},
			"requirePath": "articles/2017-06-01-get-crashlytics-ndk-working/index.md",
			"path": "/get-crashlytics-ndk-working/",
			"data": {
				"id": 10,
				"title": "Get Crashlytics NDK working",
				"date": "2017-06-01T23:00:00Z",
				"layout": "post",
				"path": "/get-crashlytics-ndk-working/",
				"category": "Android",
				"description": "Getting Crashlytics NDK working with the outdated guide is hard. Stay sane and read.",
				"readNext": "/crashlytics-ndk-and-cmake/"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-06-20-cewlrency-ux-overhaul-1",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-06-20-cewlrency-ux-overhaul-1",
				"stem": "index",
				"path": "articles/2017-06-20-cewlrency-ux-overhaul-1/index.md"
			},
			"requirePath": "articles/2017-06-20-cewlrency-ux-overhaul-1/index.md",
			"path": "/cewlrency-ux-overhaul/",
			"data": {
				"id": 11,
				"title": "Cewlrency: UX Overhaul",
				"date": "2017-06-20T23:00:00Z",
				"layout": "post",
				"path": "/cewlrency-ux-overhaul/",
				"category": "Ux Design",
				"description": "I'm rewamping my sample app Cewlrency, first step; UX"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2017-06-20-cewlrency-ux-overhaul-2",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2017-06-20-cewlrency-ux-overhaul-2",
				"stem": "index",
				"path": "articles/2017-06-20-cewlrency-ux-overhaul-2/index.md"
			},
			"requirePath": "articles/2017-06-20-cewlrency-ux-overhaul-2/index.md",
			"path": "/cewlrency-icon-drafting/",
			"data": {
				"id": 12,
				"title": "Cewlrency: Icon drafting",
				"date": "2017-06-20T23:30:00Z",
				"layout": "post",
				"path": "/cewlrency-icon-drafting/",
				"category": "Ux Design",
				"description": "Designing a material icon"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2018-04-05-play-internal-test-channel",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2018-04-05-play-internal-test-channel",
				"stem": "index",
				"path": "articles/2018-04-05-play-internal-test-channel/index.md"
			},
			"requirePath": "articles/2018-04-05-play-internal-test-channel/index.md",
			"path": "/play-internal-test-channel/",
			"data": {
				"id": 13,
				"title": "Plays' new deployment channel",
				"date": "2018-04-05T19:00:00Z",
				"layout": "post",
				"path": "/play-internal-test-channel/",
				"category": "Android Continuous Delivery",
				"description": "Google Play recently introduced the Internal Test channel, expanding the available deployment channels to Internal Test -> Alpha -> Beta -> Production. In contrast to the other channels where deploying is delayed by ~30 minutes, Internal Test will instantly deploy your builds to Play making deployment to device instant! Awesome!"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx"
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md"
			},
			"requirePath": "pages/about/index.md",
			"path": "/about/",
			"data": {
				"title": "About me",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages/contact/index.md"
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact/",
			"data": {
				"title": "Contact me",
				"layout": "page",
				"path": "/contact"
			}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0